import { ADD_TAG, GET_ALL_TAGS } from '../actions/types';

export interface TagsState {
  tags?: any[];
  [k: string]: any;
}

export const tagsInitialState: TagsState = {
  tags: [],
};

export const TagsReducer = (
  state: TagsState = tagsInitialState,
  action: {
    type: string;
    payload: any;
  }
) => {
  switch (action.type) {
    case GET_ALL_TAGS:
      return {
        ...state,
        tags: action.payload,
      };
      case ADD_TAG:  
      return {  
        ...state,  
        tags: [...state?.tags!, action.payload],  
        
      };
    default:
      return state;
  }
};
